export enum EUsersRole {
  // App roles
  SELLER = 'seller',
  AGENT = 'agent',
  // Back office roles
  SUPER_ADMIN = 'superadmin',

  SURVEYOR = 'surveyor',
  SECRETARY = 'secretary',
  ACCOUNT = 'account',
  ACCOUNTANT = 'accountant',
  PARTNER = 'partner',
}
